interface EddyAvatarProps {
  size?: number;
  className?: string;
}

// Eddy's mark — a simple bridge arc over a baseline, in brand emerald.
// Placeholder identity; swap for final art in public/eddy-avatar.svg later.
export function EddyAvatar({ size = 40, className = '' }: EddyAvatarProps) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-brand-600 ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg
        width={size * 0.58}
        height={size * 0.58}
        viewBox="0 0 24 24"
        fill="none"
        stroke="#ffffff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* bridge arc */}
        <path d="M3 15a9 9 0 0 1 18 0" />
        {/* deck */}
        <path d="M2 15h20" />
        {/* supports */}
        <path d="M7 15v4M12 15v4M17 15v4" />
      </svg>
    </span>
  );
}
